<template>
  <div class="times-repeat mt-6">
    <daily
      v-if="REPEAT_TIMES.Daily === mode"
      :is-all-day="isAllDay"
      :repeat-on="repeatOn"
    ></daily>
    <weekly
      v-else-if="REPEAT_TIMES.Weekly === mode"
      :is-all-day="isAllDay"
      :repeat-on="repeatOn"
    ></weekly>
    <irregularly
      v-else
      :is-all-day="isAllDay"
      :repeat-on="repeatOn"
      @update-repeat="repeatOn => updateRepeatOn(repeatOn)"
    ></irregularly>
  </div>
</template>

<script>
import Daily from "./Daily.vue";
import Weekly from "./Weekly.vue";
import Irregularly from "./Irregularly.vue";

import { REPEAT_TIMES } from "@/pages/Schedule/Event/event-utils";

export default {
  components: { Daily, Weekly, Irregularly },
  props: ["mode", "isAllDay", "repeatOn"],
  data() {
    return {
      REPEAT_TIMES: REPEAT_TIMES
    };
  },
  methods: {
    updateRepeatOn(newRepeatOn) {
      this.$emit("update:repeatOn", newRepeatOn);
    }
  }
};
</script>

<style lang="scss" scoped></style>
